























import Vue from "vue";

export default Vue.extend({
  name: "HealthAuthorizationNotice",
  props: {
    authorization: { type: String, required: true },
    actionPending: { type: Boolean, default: false }
  },
  computed: {
    title(): string {
      return this.authorization === "partial" ? "Há categorias para revisar" : "Acesso aos dados não autorizado";
    },
    description(): string {
      return this.authorization === "partial"
        ? "Revise as permissões no sistema de saúde do aparelho para escolher as categorias que deseja compartilhar."
        : "Abra as configurações do aparelho para autorizar a leitura das categorias que deseja compartilhar com a Omint.";
    }
  }
});
